"use client";

import React from "react";

export function Header15() {
  return (
    <section id="hero" aria-labelledby="hero-heading" className="px-[5%] py-16 md:py-24 lg:py-28" style={{ backgroundColor: '#FFFFFF', color: '#0B1F33', paddingTop: '24px' }}>
      <div className="container">
        <div className="hero-text-block rb-12 mb-6 grid grid-cols-1 items-start gap-x-12 gap-y-5 md:mb-18 md:grid-cols-2 md:gap-y-8 lg:mb-20 lg:gap-x-20 lg:gap-y-16">
          <div>
            <p className="hero-eyebrow" style={{ color: '#087cc1', textTransform: 'uppercase', letterSpacing: '1.5px', fontSize: '13px', fontWeight: '600', lineHeight: '1', margin: '0 0 24px 0', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true" style={{ flexShrink: '0' }}>
                <path d="M13 2 4.5 13.5a.6.6 0 0 0 .48.96H11l-1.06 7.42a.4.4 0 0 0 .72.32L19.5 10.5a.6.6 0 0 0-.48-.96H13l1.06-7.42a.4.4 0 0 0-.72-.32Z" />
              </svg>
              Fast Response
            </p>
            <h1 id="hero-heading" style={{ color: '#0B1F33', margin: '0 0 12px 0' }}>
              Cape Town <span style={{ color: '#087cc1' }}>Aircon Repairs</span>, Installs &amp; Servicing
            </h1>
          </div>
          <div>
            <p className="md:text-md" style={{ color: '#3F5368', fontSize: '16px', lineHeight: '1.5', margin: '0 0 16px 0' }}>
              Tell us what your aircon is doing and we'll take it from there: Fast Response, most areas across the whole western cape.
            </p>
            <div className="hero-actions" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '40px' }}>
              <a href="tel:+27213880026" className="hero-btn hero-btn-call" style={{ width: '200px', height: '56px', padding: '0 18px', borderRadius: '4px', fontSize: '16px', fontWeight: '600', lineHeight: '1', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', textDecoration: 'none', background: '#087cc1', color: '#FFFFFF', border: 'none', gap: '10px', transition: 'transform .2s ease, background .2s ease, color .2s ease', cursor: 'pointer' }}>
                <img src="/Icons/Hero icons/Phone call.svg" alt="" style={{ width: '26px', height: '26px' }} />
                Call 021 388 0026
              </a>
              <a href="https://wa.me/27646838245" target="_blank" rel="noopener noreferrer" className="hero-btn hero-btn-whatsapp" style={{ width: '200px', height: '56px', padding: '0 18px', borderRadius: '4px', fontSize: '16px', fontWeight: '600', lineHeight: '1', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', textDecoration: 'none', background: '#25D366', color: '#FFFFFF', border: 'none', gap: '10px', transition: 'transform .2s ease, background .2s ease, color .2s ease', cursor: 'pointer' }}>
                <img src="/Icons/Hero icons/whatsapp.svg" alt="" style={{ width: '26px', height: '26px' }} />
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
        <div className="hero-image-wrap">
          <img
            src="/Homepage/Hero.webp"
            className="w-full object-cover"
            alt="Cape Town aircon services - installation, repairs and servicing"
            width="1179"
            height="736"
            fetchpriority="high"
            decoding="async"
          />
        </div>
      </div>
      <style>{`
        @media (max-width: 640px) {
          .hero-actions {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
          }
          .hero-btn {
            width: 100% !important;
            height: 50px !important;
            padding: 0 16px !important;
          }
        }
        /* Mobile-only hero polish — tight text container + full-bleed image.
           Desktop/tablet (>=768px) is pixel-identical to before. */
        @media (max-width: 767px) {
          /* Zero out section horizontal padding (was px-[5%]) and reduce
             top padding (override global 80px section rule). */
          .relume-page #hero {
            padding-top: 24px !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
          }
          /* Make container full-width so the image can bleed edge-to-edge.
             Overrides global .relume-page .container { width: calc(100% - 48px) !important }. */
          .relume-page #hero .container {
            width: 100% !important;
            max-width: 100% !important;
          }
          /* Tight 24px horizontal padding on the text block only —
             H1, paragraph, and CTAs get a compact container.
             Zero row gap so the H1's 8px margin-bottom is the only
             spacer between heading and paragraph (was gap-y-5 = 20px). */
          .relume-page #hero .hero-text-block {
            padding-left: 24px !important;
            padding-right: 24px !important;
            row-gap: 0 !important;
          }
          /* Slightly reduce H1 size and line-height on mobile. */
          .relume-page #hero h1 {
            font-size: 32px !important;
            line-height: 1.05 !important;
          }
          /* Tighten paragraph line-height slightly. */
          .relume-page #hero p {
            line-height: 1.5 !important;
          }
          /* Reduce gap between paragraph and CTA buttons (was 40px inline). */
          .relume-page #hero .hero-actions {
            margin-top: 22px !important;
          }
          /* Full-bleed image — touches both viewport edges, zero radius
             (rounded corners on a full-bleed image look broken).
             aspect-ratio makes it slightly taller for a strong visual anchor. */
          .relume-page #hero .hero-image-wrap {
            aspect-ratio: 16 / 10;
          }
          .relume-page #hero .hero-image-wrap img {
            height: 100% !important;
            border-radius: 0 !important;
          }
        }
      `}</style>
    </section>
  );
}